import { createSimpleContext } from "@opencode/ui/context"
import { ServerConnection } from "./registry"
import { useGlobal } from "./runtime"

// Must be keyed for now
export const { use: useServer, provider: ServerProvider } = createSimpleContext({
  name: "Server",
  init: (props: { conn: ServerConnection.Any }) => {
    const conn = props.conn
    const key = ServerConnection.key(conn)

    const global = useGlobal()

    return {
      conn,
      key,
      isLocal: ServerConnection.local(props.conn),
      ctx: global.ensureServerCtx(conn),
      get health() {
        return global.servers.health[key]
      },
    }
  },
})

export const useData = () => {
  const server = useServer()
  return server.ctx.data
}
